import { ApiClientErrorResponse } from '~/ApiClient';

import ItemsLimitError from './ItemsLimitError';

const AddItemsLimitErrorCode = 'product-group-add-items-limit';

export default class UserProductGroupErrorResponse extends ApiClientErrorResponse {
	handleProductGroupNotFound(): boolean {
		return this.handle('product-group-not-found');
	}

	handleProductGroupLocked(): boolean {
		return this.handle('product-group-locked');
	}

	handleProductGroupCustomerDoesNotHaveSubscriptionForSystemModule(): boolean {
		return this.handle('product-group-customer-does-not-have-subscription-for-system-module');
	}

	handleProductGroupTemplateNotFound(): boolean {
		return this.handle('product-group-template-not-found');
	}

	handleProductGroupParentNotFound(): boolean {
		return this.handle('product-group-parent-not-found');
	}

	handleProductGroupAddItemsLimit(): boolean {
		return this.handle(AddItemsLimitErrorCode);
	}

	findAddItemsLimitError(): ItemsLimitError | null {
		const error = this.errors.find((candidate) => candidate.code === AddItemsLimitErrorCode);
		return error !== undefined ? new ItemsLimitError(error.meta.actual, error.meta.limit) : null;
	}
}
